import React, { useState, useEffect } from 'react';
import moment from 'moment';
import store from '../../store';
import { withRouter } from 'react-router-dom';
import { Form, Field, Loader, Row } from '@smartplatform/ui';

import WorkplanDay from './WorkplanDay';
import './styles.scss';

const getDuration = (start, due) => {
	return moment(due).diff(start, 'days');
};

const Workplan = () => {
	const [days, setDays] = useState();
	const [workplan, setWorkplan] = useState();
	useEffect(() => {
		const getWorkplan = async () => {
			let workplanData = await store.model.ChairpersonWorkplan.find({ include: 'day' });
			if (workplanData.totalCount === 0) {
				const newWorkplan = new store.model.ChairpersonWorkplan();
				workplanData = newWorkplan;
			} else {
				workplanData = workplanData[0];
			}
			setWorkplan(workplanData);
			const days = await workplanData.day({ include: ['time'] });
			setDays(days.slice(0, getDuration(workplanData.startDate, workplanData.dueDate) + 1));
		};
		getWorkplan();
	}, []);

	if (!workplan || !days) {
		return <Loader />;
	}

	const onDateChange = async plan => {
		const duration = getDuration(plan.startDate, plan.dueDate);
		const prevDays = await store.model.ChairpersonWorkplanDay.find();
		const newDays = [];
		let { startDate: currentDate } = plan;
		for (const [index] of new Array(duration + 1).fill().entries()) {
			const currentDay = prevDays.totalCount > index ? prevDays[index] : await plan.day.create({ date: currentDate });
			currentDay.date = currentDate;
			await currentDay.save();

			newDays.push(currentDay);
			currentDate = moment(currentDate).add(1, 'd');
		}
		setDays(newDays);
	};

	return (
		<div>
			<Form record={workplan} noDelete stay saveTitle="Изменить даты" onSave={onDateChange}>
				<Row>
					<Field property="startDate" label="Дата начала" />
					<Field property="dueDate" label="Дата окончания" />
				</Row>
			</Form>
			<div className="workplan__day">
				{days && days.map(day => <WorkplanDay key={`chiarpersonDya-${day.id}`} day={day} />)}
			</div>
		</div>
	);
};

export default withRouter(Workplan);
